import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment-timezone';
import moments from 'moment';
import { SettlementForm, SettlementResult } from 'components/SettlementList';
import { LoadingBar } from 'components/Commons';
import * as settlement_action from 'actions/settlement';

import cm from 'helpers/commons';
import toastr from 'helpers/toastr';

moment.tz.setDefault('Asia/Seoul');

class SettlementList extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    cm.propsInit(this.props);
    this.loadInvoice();
  }

  componentDidMount() {
    cm.mainTitle('정산관리');
  }

  loadInvoice = async () => {
    const { settlementAPI } = this.props;

    try {
      await settlementAPI.tradingList({ year: moments().format('YYYY') });
    } catch (e) {
      const { response } = e;

      if (response && response.data) {
        toastr('top-right', 'error', response.data.message);
      }

      console.error('###### tradingList error : ', e);
    }
  };

  render() {
    const { trading } = this.props;

    let loading = '';

    if (!trading) {
      loading = <LoadingBar />;
    }

    return (
      <main>
        {loading}

        <div style={{ marginBottom: '15px' }}>
          <div>
            2026년 3월부터 우측 상단의 <span style={{ fontWeight: 700 }}>정산관리 메뉴</span>에서 정산이 가능합니다.
          </div>
          <div>
            <a style={{ fontWeight: 700, textDecoration: 'underline' }} href="/service/finance">
              새로운 정산관리로 이동
            </a>
          </div>
        </div>

        <SettlementForm />

        <SettlementResult />
      </main>
    );
  }
}

SettlementList = connect(
  (state) => ({
    trading: state.settlement.tradingList
  }),
  (dispatch) => ({
    settlementAPI: bindActionCreators(
      {
        tradingList: settlement_action.SettlementTradingList
      },
      dispatch
    )
  })
)(SettlementList);

export default SettlementList;
